<template>

  <div class="container">
    <navBar/>

    <transition :name="routerTransition">
      <div v-if="$route.meta.breadcrumb || $route.meta.pageTitle" class="router-header flex flex-wrap items-center mb-6">
        <div
          class="content-area__heading"
          :class="{'pr-4 border-0 md:border-r border-solid border-grey-light' : $route.meta.breadcrumb}">
          <h2 class="mb-1">Resumen contenedor</h2>
        </div>
        <!-- BREADCRUMB -->
        <vx-breadcrumb class="ml-4 md:block hidden" v-if="$route.meta.breadcrumb" :route="$route" :isRTL="$vs.rtl" />
      </div>
    </transition>

    <div class="vx-row">
      <div class="vx-col sm:w-full md:w-full lg:w-2/3 mb-5">
        <vs-card class="p-2 mb-0 card-mb-none">
          <h1 class="mb-4">Resumen del contenedor</h1>

          <div class="mb-4">
            <h4 class="text-primary">Nombre del contenedor</h4>
            <p>{{ container.attributes.name }}</p>
          </div>

          <div class="mb-4">
            <h4 class="text-primary">Fecha de creación</h4>
            <p>{{ container.attributes.created_at }}</p>
          </div>

          <div class="mb-4">
            <h4 class="text-primary">Descripción del contenedor</h4>
            <p>{{ container.attributes.description }}</p>
          </div>

          <div class="mb-4">
            <h4 class="text-primary">Cantidad de documentos a firmar</h4>
            <p>{{ container.attributes.document_quantity }}</p>
          </div>
        </vs-card>
      </div>

      <div class="vx-col sm:w-full md:w-full lg:w-1/3">
        <vs-card >
          <div class="p-3">
            <h4 class="pb-2">Firma contenedor</h4>

            <span class="pb-3"> <b>Nombre del contenedor:</b>  <br><span> {{ container.attributes.name }}</span></span>

            <div v-if="!rejectEnable">
              <h3 class="pb-2 mt-5">Método de firma</h3>
              <p class="mb-4">Selecciona cual tipo de certificado de Firma Electrónica con el que deseas firmar.</p>

              <vs-button class="w-100 mb-4" color="primary" type="filled" @click="toggleTab(2)">Firmar con E.firma (SAT)</vs-button>
              <vs-button class="w-100 mb-4" color="primary" type="border" @click="toggleTab(8)">Firmar con Firel (PJF)</vs-button>

              <h3 class="pb-2 mt-5 mb-4">No quiero firmar</h3>
              <p class="mb-4">No estoy de acuerdo con lo descrito en el documento, deseo rechazar la firma</p>
              <vs-button :color="rejectEnable ? 'warning' : 'danger'" :type="rejectEnable ? undefined : 'border'" @click="rejectEnable = !rejectEnable">
                {{ rejectEnable ? 'Cancelar rechazo' : 'Rechazar firma' }}
              </vs-button>
            </div>


          </div>
        </vs-card>

        <vs-card v-if="rejectEnable">

          <div class="p-3">
            <h4 class="pb-2">Rechazar documento</h4>
            <div>
              <span class="pb-3">No estoy de acuerdo con la firma de este documento.</span>
            </div>
            <div class="pb-3">
              <p >Exposición de motivos:</p>
            </div>

            <quill-editor v-model="reject_motive" :options="editorOptions"></quill-editor>

          <br>
          <div>
            <div>
              <vs-button :disabled="isSubmitted" ref="loadableButton" id="button-with-loading" class="vs-con-loading__container mr-3" @click="submitReject" color="primary">
                Rechazar
              </vs-button>
              <vs-button :color="rejectEnable ? 'warning' : 'danger'" :type="rejectEnable ? undefined : 'border'" @click="rejectEnable = !rejectEnable">
                {{ rejectEnable ? 'Cancelar rechazo' : 'Rechazar documento' }}
              </vs-button>
            </div>
          </div>
          </div>
        </vs-card>

      </div>

    </div>
  </div>
</template>

<script>
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import { quillEditor } from 'vue-quill-editor'
import router from "@/router";
import {API_URL} from "@/config/app";
import navBar from "@/layouts/components/navbar/NavBarHorizontalLayout.vue";

export default {
  name: "SignDocument",
  props: ['toggleTab'],
  components: {
    quillEditor,
    navBar,
  },
  data () {
    return {
      isSubmitted: false,
      rejectEnable: false,
      editorOptions: {
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline','strike', 'blockquote'],
            [{'list': 'ordered'}, {'list': 'bullet'}, { 'color': ['red', 'green', 'blue', 'orange', 'violet', '#d0d1d2', 'black'] }],
          ],
        }
      },
      reject_motive: "",
      uuid: "",
      container: {},
      api_url: API_URL
    }
  },
  computed: {
    downloadLink() {
      return this.api_url + this.document.attributes.download_link;
    }
  },
  methods: {
    submitReject() {
      this.$store.dispatch("alert/clear", {}, {root:true});
      if (!this.uuid || !this.reject_motive || !this.signatureId) {
        this.$store.dispatch("alert/error", "Ingrese los datos requeridos");
        return;
      }
      this.$vs.loading({
        background: 'primary',
        color: '#fff',
        container: "#button-with-loading",
        scale: 0.45
      });
      this.isSubmitted = true;
      this.$store.dispatch("document/rejectContainer", {
        uuid: this.uuid,
        motive: this.reject_motive,
        signatureId: this.signatureId
      }).then(
        () => {
          this.toggleTab(5);
          this.$vs.loading.close("#button-with-loading > .con-vs-loading");
          this.isSubmitted = false;
        },
        () => {
          this.$vs.loading.close("#button-with-loading > .con-vs-loading");
          this.isSubmitted = false;
        }
      )
    },
  },
  created() {
    let uuid = this.$route.params.uuid;
    let signatureId = this.$route.params.signatureId;
    if (uuid && signatureId) {
      this.uuid = uuid;
      this.signatureId = signatureId;
    } else {
      router.push("/");
    }

    this.$store.dispatch("document/getContainerInformation", {uuid: this.uuid, signatureId: signatureId})
      .then(
        container => {
          this.container = container;
          console.log(this.container);
          if (this.container.attributes.sign_status === "SIGNED") {
            this.toggleTab(6);
          }
          if (this.container.attributes.sign_status === "REJECTED") {
            this.toggleTab(4);
          }
        },
        () => {
          this.toggleTab(4);
        }
      )
  }
}
</script>

<style lang="scss">
.card-mb-none{
  .vs-card--content{
    margin-bottom: 0;
  }
}
</style>
